import { Box, Stack, Text } from "@bookingcom/bui-react";

export type SearchCoverageTooltipRow = {
  name: string;
  percentage?: number;
  color: string;
};

export type SearchCoverageTooltipProps = {
  title: string;
  rows: SearchCoverageTooltipRow[];
};

export const SearchCoverageTooltip = ({ title, rows }: SearchCoverageTooltipProps) => (
  <Box backgroundColor="elevation_one" borderRadius={200} padding={0} overflow="hidden">
    <Box backgroundColor="neutral_alt" padding={3}>
      <Text variant="strong_2">{title}</Text>
    </Box>
    <Stack gap={2} mixin={{ padding: 3 }}>
      {rows.map(({ name, percentage, color }) => (
        <Stack key={name} direction="row" alignItems="center" justifyContent="space-between" gap={2}>
          <Stack direction="row" alignItems="center" gap={2}>
            <Box
              borderRadius="circle"
              padding={1.5}
              attributes={{ style: { backgroundColor: color, flexShrink: 0 } }}
            />
            <Text variant="body_2">{name}</Text>
          </Stack>
          <Text variant="strong_2">{percentage !== undefined ? `${percentage.toFixed(1)}%` : "-"}</Text>
        </Stack>
      ))}
    </Stack>
  </Box>
);
